"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
;
/**
 * A web link.
 * @internal
 */
class Link {
    /**
     * Constructs a new link.
     * @param parameters - the link's parameters.
     * @see {@link LinkParameters}
     */
    constructor(parameters) {
        const { anchor, rel, href } = parameters, attributes = __rest(parameters, ["anchor", "rel", "href"]);
        this.anchor = anchor;
        this.rel = rel;
        this.href = href;
        this.attributes = attributes;
    }
}
exports.Link = Link;
